// export const DURCON_GREEN = '#379028';
export const DURCON_GREEN = 'rgb(15, 153, 71)';
export const MOBILE_BREAKPOINT = 600;
export const MAX_FILE_SIZE = 2_000_000;